module.exports = __webpack_public_path__ + "static/media/on-demand-full-kerokan.fb8be500.svg";